module.exports = __webpack_public_path__ + "8a6b54385f2ed4d1f5580f6e55a770bc.MP3";